import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let collapse = document.querySelectorAll('[paws-component="noss-accordionitem"][paws-template="default"]');
    if (window.bootstrap != null) {
        for (let i = 0; i < collapse.length; ++i) {
            collapse[i].addEventListener('hide.bs.collapse', event => {
                event.target.closest('[paws-component="noss-accordionitem"][paws-template="default"]').classList.remove('active');
            })
            collapse[i].addEventListener('show.bs.collapse', event => {
                event.target.closest('[paws-component="noss-accordionitem"][paws-template="default"]').classList.add('active');
            })
        }
    }
}